<template>
  <div id="jurisdiction">
    <el-card class="box-card">
      <div
        slot="header"
        class="clearfix"
        element-loading-text="加载中..."
        element-loading-background="rgba(0, 0, 0, 0.4)"
        v-loading.fullscreen.lock="fullscreenLoading"
      >
        <div slot="header" class="clearfix dettit">
          <span>权限管理&nbsp;/&nbsp;角色组</span>
          <el-button type="success" @click="addpeop('role:add')"
            >添加</el-button
          >
        </div>
        <el-dialog
          title="添加/编辑角色"
          :visible.sync="dialogFormVisible"
          :before-close="handleClose"
          width="60%"
        >
          <div>
            <span>* 角色名</span
            ><el-input
              v-model="tempRole.roleName"
              style="width: 50%; margin: 0 2%"
            ></el-input>
          </div>
          <div style="margin: 18px 0">
            <span style="margin: 0 16px 0 0">* 状&nbsp;&nbsp;&nbsp;态</span
            ><el-radio v-model="xzqy" label="1">启用</el-radio
            ><el-radio v-model="xzqy" label="3">禁用</el-radio>
          </div>
          <div style="display: flex; align-items: baseline">
            <span style="margin-right: 4px">* 权&nbsp;&nbsp;&nbsp;限</span
            ><el-tree
              :data="data4"
              show-checkbox
              node-key="id"
              ref="tree"
              @check-change="handleCheckChange"
              default-expand-all
              :default-checked-keys="xz"
            >
            </el-tree>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="createRole">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <Week @childFn="parentFn"></Week>
      <el-input
        v-model="newName"
        placeholder="角色名"
        class="elinputs"
      ></el-input>
      <el-select v-model="deleteStatus" placeholder="状态" class="elinputs">
        <el-option
          v-for="item in statlist"
          :key="item.deleteStatus"
          :label="item.label"
          :value="item.deleteStatus"
        >
        </el-option>
      </el-select>
      <el-date-picker
        style="margin: 0 16px 0 0"
        v-model="zctime"
        type="daterange"
        value-format="yyyy-MM-dd"
        @blur="time"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker
      ><el-button type="primary" @click="query">查询</el-button>
      <el-button type="info" @click="reset" style="margin: 6px 10px 14px"
        >重置</el-button
      >
      <el-table
        :data="tableData"
        border
        stripe
        :sort-method="sortChange1"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" :index="1" width="80">
        </el-table-column>
        <el-table-column prop="roleName" min-width="160" label="角色名">
        </el-table-column>
        <el-table-column prop="areasName" min-width="260" label="所属地区">
        </el-table-column>
        <el-table-column prop="addName" label="创建者" width="120">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span
              class="boldfont"
              v-if="scope.row.deleteStatus == '1'"
              style="color: #67c23a"
              >启用</span
            >
            <span
              class="boldfont"
              v-if="scope.row.deleteStatus == '3'"
              style="color: #f56c6c"
              >禁用</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          min-width="160"
          sortable
          label="创建时间"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          min-width="160"
          sortable
          label="更新时间"
        >
        </el-table-column>

        <el-table-column min-width="180" fixed="right" label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.roleId == 1"><el-tag>全部权限</el-tag></div>
            <el-button
              v-if="scope.row.roleId != 1"
              size="mini"
              type="success"
              @click="showUpdate(scope.row, scope.$index, 'role:update')"
              ><i class="el-icon-edit"></i> 编辑</el-button
            >
            <el-button
              v-if="scope.row.roleId != 1"
              size="mini"
              type="danger"
              @click="handleDelete(scope.row, 'role:delete')"
              ><i class="el-icon-delete"></i> 删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import Week from "@/components/Week";
export default {
  name: "jurisdiction",
  components: {
    Week,
  },
  data() {
    return {
      statlist: [
        {
          deleteStatus: "1",
          label: "启用",
        },
        {
          deleteStatus: "3",
          label: "禁用",
        },
      ],
      deleteStatus: "",
      pageNum: 1,
      pageSize: 10,
      adminAreasId: "",
      tableData: [],
      name: "",
      dialogFormVisible: false,
      roleName: "",
      formLabelWidth: "120px",
      nav: [],
      userdata: {},
      opentree: false,
      allPermission: [],
      tempRole: {
        roleName: "",
        roleId: "",
        permissions: [],
      },
      xzqy: "1",
      stat: "",
      fullscreenLoading: true,
      data3: [
        {
          id: "444",
          label: "全部权限",
          children: [
            {
              id: "445",
              label: "首页",
              children: [],
            },
            {
              id: "446",
              label: "报备查询",
              children: [],
            },
            {
              id: "447",
              label: "统计查询",
              children: [],
            },
            {
              id: "448",
              label: "人员管理",
              children: [],
            },
            {
              id: "449",
              label: "网站管理",
              children: [],
            },
            {
              id: "450",
              label: "权限管理",
              children: [],
            },
            {
              id: "451",
              label: "站点管理",
              children: [],
            },
            {
              id: "452",
              label: "监控管理",
              children: [],
            },
            {
              id: "453",
              label: "培训考试",
              children: [],
            },
            {
              id: "454",
              label: "商城用户",
              children: [],
            },
            {
              id: "456",
              label: "优惠券管理",
              children: [],
            },
            {
              id: "457",
              label: "订单管理",
              children: [],
            },
            {
              id: "458",
              label: "商品管理",
              children: [],
            },
            {
              id: "459",
              label: "运输溯源",
              children: [],
            },
            {
              id: "460",
              label: "采购溯源",
              children: [],
            },
          ],
        },
      ],
      data4: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      xz: [],
      radio: "1",
      zctime: "",
      pro: [],
      prolist: [],
      city: [],
      citylist: [],
      area: [],
      arealist: [],
      town: [],
      townlist: [],
      village: [],
      villagelist: [],
      region: [],
      modify: false,
      areasName: "",
      stat: "0",
      areaId: "",
      newName: "",
      listnum: 1,
      btn: [],
    };
  },
  created() {
    this.initial();
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
  },
  computed: {
    data() {
      return this.xz;
    },
  },
  mounted() {
    let region = JSON.parse(localStorage.getItem("region"));
    this.$set(this, "region", region);
    region.forEach((x) => {
      if (x.level == 0) {
        this.prolist.push(x);
      }
    });
    // 查询权限
    this.$axios
      .post(
        `/api-r/permission/getAllPermissionInfo/${this.userdata.roleId}`,
        {},
        { headers: { accessToken: this.userdata.token } }
      )
      .then((res) => {
        let arr = this.data3;
        let obj = res.data.permissionList;
        // let nuarr = []
        obj.forEach((x) => {
          if (x.menuName != null) {
            x.label = x.menuName;
          }
          x.permissions.forEach((y) => {
            y.label = y.permissionName;
          });

          if (x.menuName == "首页") {
            arr[0].children[0].children = x.permissions;
          }
          if (x.menuName == "报备查询") {
            arr[0].children[1].children = x.permissions;
          }
          if (
            x.menuName == "报备统计" ||
            x.menuName == "办宴统计" ||
            x.menuName == "乡厨统计" ||
            x.menuName == "管理员统计" ||
            x.menuName == "周报表" ||
            x.menuName == "日报表"
          ) {
            arr[0].children[2].children = [
              { label: "报备统计", id: "461", children: [] },
              { label: "办宴统计", id: "462", children: [] },
              { label: "乡厨统计", id: "463", children: [] },
              { label: "管理员统计", id: "464", children: [] },
              { label: "周报表", id: "465", children: [] },
              { label: "日报表", id: "466", children: [] },
            ];
          }
          if (
            x.menuName == "乡厨管理" ||
            x.menuName == "食安办管理" ||
            x.menuName == "协管员管理" ||
            x.menuName == "帮厨管理"
          ) {
            arr[0].children[3].children = [
              { label: "乡厨管理", id: "467", children: [] },
              { label: "食安办管理", id: "468", children: [] },
              { label: "协管员管理", id: "469", children: [] },
              { label: "帮厨管理", id: "470", children: [] },
            ];
          }
          // if(x.menuName == '基础信息'||x.menuName == '协议管理'){
          //    arr[0].children[4].children = [{label: '基础信息',id:'127',children: []},{label: '协议管理',id:'128',children: []}]
          // }
          if (x.menuName == "基础信息" || x.menuName == "协议管理") {
            arr[0].children[4].children = [
              { label: "基础信息", id: "471", children: [] },
              { label: "协议管理", id: "472", children: [] },
            ];
          }
          if (
            x.menuName == "管理员列表" ||
            x.menuName == "权限管理" ||
            x.menuName == "短信管理"
          ) {
            arr[0].children[5].children = [
              { label: "管理员列表", id: "473", children: [] },
              { label: "角色组", id: "474", children: [] },
              { label: "短信管理", id: "475", children: [] },
              { label: "报备字段管理", id: "502", children: [] },
            ];
          }
          if (x.menuName == "站点管理") {
            arr[0].children[6].children = [
              { label: "站点管理", id: "476", children: [] },
            ];
          }
          if (x.menuName == "办宴点管理" || x.menuName == "摄像头管理") {
            arr[0].children[7].children = [
              { label: "办宴点管理", id: "477", children: [] },
              { label: "摄像头管理", id: "478", children: [] },
            ];
          }
          if (
            x.menuName == "知识管理" ||
            x.menuName == "视频管理" ||
            x.menuName == "培训banner管理" ||
            x.menuName == "题库管理" ||
            x.menuName == "答题管理"
          ) {
            arr[0].children[8].children = [
              { label: "知识管理", id: "479", children: [] },
              { label: "视频管理", id: "480", children: [] },
              { label: "banner管理", id: "481", children: [] },
              { label: "题库管理", id: "482", children: [] },
              { label: "答题管理", id: "483", children: [] },
            ];
          }
          if (
            x.menuName == "商城用户管理" ||
            x.menuName == "地址管理" ||
            x.menuName == "积分活动"
          ) {
            arr[0].children[9].children = [
              { label: "用户列表", id: "484", children: [] },
              { label: "地址管理", id: "485", children: [] },
              { label: "积分活动", id: "486", children: [] },
            ];
          }
          if (x.menuName == "优惠券管理") {
            arr[0].children[10].children = [
              { label: "优惠券管理", id: "487", children: [] },
            ];
          }
          if (x.menuName == "订单管理") {
            arr[0].children[11].children = [
              { label: "订单列表", id: "488", children: [] },
            ];
          }
          if (
            x.menuName == "商品列表管理" ||
            x.menuName == "商品分类管理" ||
            x.menuName == "活动管理" ||
            x.menuName == "商城banner管理" ||
            x.menuName == "推荐管理" ||
            x.menuName == "评价管理" ||
            x.menuName == "关键字管理"
          ) {
            arr[0].children[12].children = [
              { label: "商品列表", id: "489", children: [] },
              { label: "商品分类", id: "490", children: [] },
              { label: "活动管理", id: "491", children: [] },
              { label: "banner管理", id: "492", children: [] },
              { label: "商品推荐管理", id: "493", children: [] },
              { label: "商品评价管理", id: "494", children: [] },
              { label: "关键词管理", id: "495", children: [] },
            ];
          }
          if (
            x.menuName == "车辆管理" ||
            x.menuName == "司机管理" ||
            x.menuName == "运输管理"
          ) {
            arr[0].children[13].children = [
              { label: "车辆管理", id: "496", children: [] },
              { label: "司机管理", id: "497", children: [] },
              { label: "运输管理", id: "498", children: [] },
            ];
          }
          if (
            x.menuName == "采购员管理" ||
            x.menuName == "供应商管理" ||
            x.menuName == "食材管理"
          ) {
            arr[0].children[14].children = [
              { label: "采购员管理", id: "499", children: [] },
              { label: "供应商管理", id: "500", children: [] },
              { label: "食材管理", id: "501", children: [] },
            ];
          }
        });
        obj.forEach((x) => {
          if (x.menuName == "报备统计") {
            arr[0].children[2].children[0].children = x.permissions;
          }
          if (x.menuName == "办宴统计") {
            arr[0].children[2].children[1].children = x.permissions;
          }
          if (x.menuName == "乡厨统计") {
            arr[0].children[2].children[2].children = x.permissions;
          }
          if (x.menuName == "管理员统计") {
            arr[0].children[2].children[3].children = x.permissions;
          }
          if (x.menuName == "周报表") {
            arr[0].children[2].children[4].children = x.permissions;
          }
          if (x.menuName == "日报表") {
            arr[0].children[2].children[5].children = x.permissions;
          }
          if (x.menuName == "乡厨管理") {
            arr[0].children[3].children[0].children = x.permissions;
          }
          if (x.menuName == "食安办管理") {
            arr[0].children[3].children[1].children = x.permissions;
          }
          if (x.menuName == "协管员管理") {
            arr[0].children[3].children[2].children = x.permissions;
          }
          if (x.menuName == "帮厨管理") {
            arr[0].children[3].children[3].children = x.permissions;
          }
          if (x.menuName == "基础信息") {
            arr[0].children[4].children[0].children = x.permissions;
          }
          if (x.menuName == "协议管理") {
            arr[0].children[4].children[1].children = x.permissions;
          }
          if (x.menuName == "管理员列表") {
            arr[0].children[5].children[0].children = x.permissions;
          }
          if (x.menuName == "报备字段管理") {
            arr[0].children[5].children[3].children = x.permissions;
          }
          if (x.menuName == "权限管理") {
            arr[0].children[5].children[1].children = x.permissions;
          }
          if (x.menuName == "短信管理") {
            arr[0].children[5].children[2].children = x.permissions;
          }

          if (x.menuName == "站点管理") {
            arr[0].children[6].children[0].children = x.permissions;
          }

          if (x.menuName == "办宴点管理") {
            arr[0].children[7].children[0].children = x.permissions;
          }
          if (x.menuName == "摄像头管理") {
            arr[0].children[7].children[1].children = x.permissions;
          }

          if (x.menuName == "知识管理") {
            arr[0].children[8].children[0].children = x.permissions;
          }
          if (x.menuName == "视频管理") {
            arr[0].children[8].children[1].children = x.permissions;
          }
          if (x.menuName == "培训banner管理") {
            arr[0].children[8].children[2].children = x.permissions;
          }
          if (x.menuName == "题库管理") {
            arr[0].children[8].children[3].children = x.permissions;
          }
          if (x.menuName == "答题管理") {
            arr[0].children[8].children[4].children = x.permissions;
          }

          if (x.menuName == "商城用户管理") {
            arr[0].children[9].children[0].children = x.permissions;
          }
          if (x.menuName == "地址管理") {
            arr[0].children[9].children[1].children = x.permissions;
          }
          if (x.menuName == "积分活动") {
            arr[0].children[9].children[2].children = x.permissions;
          }

          if (x.menuName == "优惠券管理") {
            arr[0].children[10].children[0].children = x.permissions;
          }

          if (x.menuName == "订单管理") {
            arr[0].children[11].children[0].children = x.permissions;
          }

          if (x.menuName == "商品列表管理") {
            arr[0].children[12].children[0].children = x.permissions;
          }
          if (x.menuName == "商品分类管理") {
            arr[0].children[12].children[1].children = x.permissions;
          }
          if (x.menuName == "活动管理") {
            arr[0].children[12].children[2].children = x.permissions;
          }
          if (x.menuName == "商城banner管理") {
            arr[0].children[12].children[3].children = x.permissions;
          }
          if (x.menuName == "推荐管理") {
            arr[0].children[12].children[4].children = x.permissions;
          }
          if (x.menuName == "评价管理") {
            arr[0].children[12].children[5].children = x.permissions;
          }
          if (x.menuName == "关键字管理") {
            arr[0].children[12].children[6].children = x.permissions;
          }

          if (x.menuName == "车辆管理") {
            arr[0].children[13].children[0].children = x.permissions;
          }
          if (x.menuName == "司机管理") {
            arr[0].children[13].children[1].children = x.permissions;
          }
          if (x.menuName == "运输管理") {
            arr[0].children[13].children[2].children = x.permissions;
          }

          if (x.menuName == "采购员管理") {
            arr[0].children[14].children[0].children = x.permissions;
          }
          if (x.menuName == "供应商管理") {
            arr[0].children[14].children[1].children = x.permissions;
          }
          if (x.menuName == "食材管理") {
            arr[0].children[14].children[2].children = x.permissions;
          }
        });
        arr.forEach((x) => {
          let _arr = x.children;
          _arr.forEach((y) => {
            if (y.children.length == 0) {
              y.disabled = true;
            } else {
              let _arr1 = y.children;
              _arr1.forEach((z) => {
                if (z.children != undefined) {
                  if (z.children.length == 0) {
                    z.disabled = true;
                  }
                }
              });
            }
          });
        });
        this.data4 = arr;
      });
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.fullscreenLoading = true;
      this.initial();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.fullscreenLoading = true;
      this.initial();
    },
    sortChange1(a, b) {
      console.log(a, b);
    },
    query() {
      this.pageNum = 1;
      this.fullscreenLoading = true;
      this.initial();
    },
    reset() {
      this.$router.push("/refresh");
    },
    adddz() {
      this.stat = 1;
    },
    // sheng(val){
    //   let ceshi = []
    //   if(this.userdata.level==0){
    //       if(val.length==1){
    //           let ces = this.$qs.stringify({
    //               areasId:val[0].id
    //           })
    //           this.$axios.post(`/api-r/area/getSubordinateAreaList`,ces,{headers:{accessToken:this.userdata.token}})
    //           .then(res=>{
    //               if(res.data.success){
    //                   this.$set(this,'citylist',res.data.areaListInfoList)
    //               }
    //           })
    //       }else{
    //           this.$set(this,'citylist',[])
    //       }
    //   }else{
    //       this.region.forEach(x => {
    //           if(x.level==1){
    //               ceshi.push(x)
    //           }
    //       });
    //       this.$set(this,'citylist',ceshi)
    //   }
    //   this.$set(this,'city','')
    //   this.$set(this,'area','')
    //   this.$set(this,'town','')
    //   this.$set(this,'village','')
    //   this.$set(this,'arealist',[])
    //   this.$set(this,'townlist',[])
    //   this.$set(this,'villagelist',[])
    // },
    // shi(val){
    //     let arr = []
    //     if(this.userdata.level<=1){
    //         if(val.length==1){
    //             let ces = this.$qs.stringify({
    //                 areasId:val[0].id
    //             })
    //             this.$axios.post(`/api-r/area/getSubordinateAreaList`,ces,{headers:{accessToken:this.userdata.token}})
    //             .then(res=>{
    //                 // console.log(res)
    //                 if(res.data.success){
    //                     this.$set(this,'arealist',res.data.areaListInfoList)
    //                 }
    //             })
    //         }else{
    //             this.$set(this,'arealist',[])
    //         }
    //     }else{
    //         this.region.forEach(x => {
    //             if(x.level==2){
    //                 arr.push(x)
    //             }
    //         });
    //         this.$set(this,'arealist',arr)
    //     }
    //     this.$set(this,'area','')
    //     this.$set(this,'town','')
    //     this.$set(this,'village','')
    //     this.$set(this,'townlist',[])
    //     this.$set(this,'villagelist',[])
    // },
    // qu(val){
    //     let arr = []
    //     if(this.userdata.level<=2){
    //         if(val.length==1){
    //             let ces = this.$qs.stringify({
    //                 areasId:val[0].id
    //             })
    //             this.$axios.post(`/api-r/area/getSubordinateAreaList`,ces,{headers:{accessToken:this.userdata.token}})
    //             .then(res=>{
    //                 // console.log(res)
    //                 if(res.data.success){
    //                     this.$set(this,'townlist',res.data.areaListInfoList)
    //                 }
    //             })
    //         }else{
    //             this.$set(this,'townlist',[])
    //         }
    //     }else{
    //         this.region.forEach(x => {
    //             if(x.level==3){
    //                 arr.push(x)
    //             }
    //         });
    //         this.$set(this,'townlist',arr)
    //     }
    //     this.$set(this,'town','')
    //     this.$set(this,'village','')
    //     this.$set(this,'villagelist',[])
    // },
    // xiang(val){
    //     let arr = []
    //     if(this.userdata.level<=3){
    //         if(val.length==1){
    //             let ces = this.$qs.stringify({
    //                 areasId:val[0].id
    //             })
    //             this.$axios.post(`/api-r/area/getSubordinateAreaList`,ces,{headers:{accessToken:this.userdata.token}})
    //             .then(res=>{
    //                 // console.log(res)
    //                 if(res.data.success){
    //                     this.$set(this,'villagelist',res.data.areaListInfoList)
    //                 }
    //             })
    //         }else{
    //             this.$set(this,'villagelist',[])
    //         }
    //     }else{
    //         this.region.forEach(x => {
    //             if(x.level==4){
    //                 arr.push(x)
    //             }
    //         });
    //         this.$set(this,'villagelist',arr)
    //     }
    //     this.$set(this,'village','')
    // },
    time() {
      console.log(this.zctime);
    },
    handleClose(done) {
      this.$router.push("/refresh");
      this.dialogFormVisible = false;
    },
    handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes();
      let arr = [];
      res.forEach((item) => {
        if (item.id < 400) {
          arr.push(item.id);
        }
      });
      this.tempRole.permissions = arr;
    },
    addpeop(hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.modify = false;
      this.tempRole = {
        roleName: "",
        roleId: "",
        permissions: [],
      };
      this.stat == "";
      this.$set(this, "stat", 1);

      this.dialogFormVisible = true;
      setTimeout(function () {
        let a = document.querySelectorAll("div.el-tree-node__content");
        for (let i = 0; i < a.length; i++) {
          if (a[i].style.paddingLeft == "54px") {
            a[i].style.width = "80px";
            a[i].style.float = "left";
          }
        }
      }, 1000);
    },
    handleDelete(row, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(
              `/api-r/permission/deleteRole/${row.roleId}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              if (res.data.success) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.initial();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    showUpdate(i, $index, hint) {
      if (this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      let arr = [];
      this.$set(this, "xz", []);
      i.menus.forEach((x) => {
        x.permissions.forEach((y) => {
          arr.push(y.permissionId);
        });
      });
      this.$set(this, "stat", 1);
      this.$set(this, "xz", arr);
      this.tempRole.permissions = arr;
      this.tempRole.roleId = i.roleId;
      this.tempRole.roleName = i.roleName;
      this.xzqy = i.deleteStatus;
      this.areasName = i.areasName;
      this.modify = true;
      this.$set(this, "stat", 0);
      this.dialogFormVisible = true;
      setTimeout(function () {
        let a = document.querySelectorAll("div.el-tree-node__content");
        for (let i = 0; i < a.length; i++) {
          if (a[i].style.paddingLeft == "54px") {
            a[i].style.width = "80px";
            a[i].style.float = "left";
          }
        }
      }, 1000);
    },
    initial() {
      let userdata = JSON.parse(sessionStorage.getItem("userdata"));
      this.$set(this, "userdata", userdata);
      this.$set(this, "adminAreasId", userdata.areasId);
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        adminAreasId: userdata.areasId,
        startTime: this.zctime[0],
        endTime: this.zctime[1],
        deleteStatus: this.deleteStatus,
        roleName: this.newName,
        areaId: this.areaId,
      });
      this.$axios
        .post(`/api-r/permission/getRoleListInfo`, data, {
          headers: { accessToken: userdata.token },
        })
        .then((res) => {
          // console.log(res,'角色列表')
          this.fullscreenLoading = false;
          this.$set(this, "tableData", res.data.roleMaps);
        });
    },
    createRole() {
      if (this.tempRole.roleName == "") {
        return this.$message("请填写用户名");
      }
      if (this.tempRole.permissions.toString() == "") {
        return this.$message("请至少选择一项权限");
      }
      let data2 = this.$qs.stringify({
        permissions: this.tempRole.permissions.toString(),
        roleName: this.tempRole.roleName,
        roleId: this.tempRole.roleId,
        deleteStatus: this.xzqy,
        // areasExtend:areasId.join(','),
        // areasName:areasName.join(','),
      });
      let data1 = this.$qs.stringify({
        permissions: this.tempRole.permissions.toString(),
        roleName: this.tempRole.roleName,
        deleteStatus: this.xzqy,
        // areasExtend:areasId.join(','),
        // areasName:areasName.join(','),
        adminId: JSON.parse(sessionStorage.getItem("userdata")).id,
      });
      if (this.modify == true) {
        this.$axios
          .post(`/api-r/permission/updateRole`, data2, {
            headers: { accessToken: this.userdata.token },
          })
          .then((res) => {
            if (res.data.success) {
              this.$router.push("/refresh");
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.dialogFormVisible = false;
              this.initial();
            } else {
              alert(res.data.msg);
            }
          });
      } else {
        this.$axios
          .post(`/api-r/permission/addRole`, data1, {
            headers: { accessToken: this.userdata.token },
          })
          .then((res) => {
            if (res.data.success) {
              this.$router.push("/refresh");
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.dialogFormVisible = false;
              this.initial();
            } else {
              alert(res.data.msg);
            }
          });
      }

      if (this.pro != "") {
        if (this.pro == "") {
          return this.$message("请选择地区分配");
        }
        let data = "";
        //添加新角色
        let url = "";
        if (this.pro != "") {
          if (this.userdata.level == 1) {
            if (this.pro == "" || this.city == "") {
              return this.$message("请完善省级和市级分配");
            }
          }
          if (this.userdata.level == 2) {
            if (this.pro == "" || this.city == "" || this.area == "") {
              return this.$message("请完善省级、市级、区域分配");
            }
          }
          if (this.userdata.level == 3) {
            if (
              this.pro == "" ||
              this.city == "" ||
              this.area == "" ||
              this.town == ""
            ) {
              return this.$message("请完善省级、市级、区域、乡/镇分配");
            }
          }
          if (this.userdata.level == 4) {
            if (
              this.pro == "" ||
              this.city == "" ||
              this.area == "" ||
              this.town == "" ||
              this.village == ""
            ) {
              return this.$message("请完善省级、市级、区域、乡/镇、村分配");
            }
          }
        }
        let arr = [];
        this.pro.forEach((x) => {
          arr.push(x);
        });
        if (this.city != "") {
          this.city.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.area != "") {
          this.area.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.town != "") {
          this.town.forEach((x) => {
            arr.push(x);
          });
        }
        if (this.village != "") {
          this.village.forEach((x) => {
            arr.push(x);
          });
        }
        let areasId = [];
        let areasName = [];
        arr.forEach((x) => {
          areasId.push(x.id);
          areasName.push(x.name);
        });
      }
    },
    parentFn(i) {
      this.areaId = i.id;
    },
  },
};
</script>
<style>
#jurisdiction .el-input__inner {
  margin: 10px 0;
}
#jurisdiction .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#jurisdiction .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#jurisdiction .el-form-item__content {
  margin-left: 0 !important;
}
#jurisdiction .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#jurisdiction .el-form-item {
  display: flex;
  align-items: center;
}
#jurisdiction .el-form-item {
  margin-bottom: 10px;
}
#jurisdiction .el-tree-node__content {
  margin: 6px 0;
}
#jurisdiction .el-tree-node__content:hover {
  background: none;
}
#jurisdiction .el-checkbox__inner {
  margin-right: 6px;
}
#jurisdiction .newcs {
  width: 112px;
  margin-bottom: 18px;
  margin-right: 13px;
}
#jurisdiction .el-tag {
  margin: 4px;
}
#jurisdiction .el-tree {
  width: 80%;
  margin-left: 1%;
}
/* #jurisdiction .el-button:focus, .el-button:hover{
        border: none;
        background-color: #11A983
    } */
#addput .el-input {
  width: 92%;
}
#addput .el-input__inner {
  margin: 7px 0;
}
#jurisdiction .el-dialog__body {
  height: 60vh;
}
</style>
<style scoped lang="scss">
.addbtn {
  background-color: #11A983 !important;
  color: #fff !important;
}
.rowlist {
  display: flex;
  align-items: center;
  height: 42px;
}
.rowlist .titname {
  width: 72px;
  display: inline-block;
  text-align: right;
  margin-right: 8px;
}
.dettit {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.dettit > span {
  border-left: 5px solid #11A983;
  padding-left: 8px;
}
</style>
